import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { ActivityContactList_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import RemoveContactButton from "../buttons/RemoveContactButton";
import Pagination from "../pagination/Pagination";
import PtsAlert from "../ptsAlert/PtsAlert";
import _ from "lodash";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
class ActivityContactList extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    this.state = {
      messageName: "",
      initialPage: 0,
      pageSize: 20,
      activityContactList: [],
      open: false,
      onChange: props.onChange,
    };
    this.debouncedSearch = _.debounce(this.showActivityContactList, 800);
  }

  showActivityContactList(rowData, pageNo, pageSize) {
    const postObject = {
      header: this.header,
      activityId: rowData.id,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
      },
    };
    FetchServerData.callPostService(ActivityContactList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let activityContactList = output.data.contactList;
          let page = output.data.page;
          let isPaging = false;
          for (let i = 0; i < activityContactList.length; i++) {
            activityContactList[i].mobile = Utils.viewTollFreeNumberFormate(
              activityContactList[i].mobile
            );
            activityContactList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(activityContactList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
              activityContactList[i].createdOn, true
            );
          }
          if (activityContactList.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            render: true,
            open: true,
            isPaging: isPaging,
            message: rowData,
            activityContactList: activityContactList,
            pageNo: page?.pageNo,
            showPerPage: page?.pageSize,
            totalPages: page?.totalPages,
            totalRecords: page?.total,
          });
        } else {
        }
      }
    );
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  showActionButton(rowData) {
    return (
      <>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <span className="me-2" style={{ cursor: "pointer" }}>
            <RemoveContactButton
              domainObject={rowData.mobile}
              // onClick={this.deleteContactToGroup.bind(this, rowData)}
              pageId="ActivityContact"
            />
          </span>
        </div>
      </>
    );
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });
    this.showActivityContactList(
      this.state.message,
      currentPageIndex,
      pageSize
    );
  }

  deleteContactToGroup(data) {
    const postObject = {
      header: this.header,
      activityId: data.activityId,
      contactId: data.contactId,
    };

    FetchServerData.callPostService(
      "/activityMs/removeContactFromActivitiy",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.state.onChange();
          this.showActivityContactList(
            this.state.message,
            this.state.pageNo,
            this.state.pageSize
          );
        } else {
        }
      })
      .catch((error) => { });
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.message,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose.bind(this)}
        maxWidth="xl"
        className="salesDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>
            {`Activity List: ${this.state.message?.messageName}`}
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent>
          <div className="row mt-2">
            <div className="col md-12">
              <div className="row justify-content-between pb-2">
                <div className="d-flex col-12 col-lg-4 col-xl-4">
                  <div className="col-12 text-start totalResults">
                    <span>Total Results: {this.state.totalRecords}</span>
                  </div>
                </div>
                <div className="d-flex col-12 col-lg-8 col-xl-8">
                  <div className="col-12 text-end">
                    <TextField
                      id="standard-search"
                      placeholder="Search"
                      type="text"
                      variant="standard"
                      value={this.state.searchText}
                      onChange={this.onSearchChange.bind(this)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton
                              onClick={this.showActivityContactList.bind(
                                this,
                                this.state.message,
                                this.state.pageNo,
                                this.state.pageSize
                              )}
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="table-responsive paginationTable MuiPaper-elevation2">
                <table className="table text-start table-hover  mb-0">
                  <thead className="dialogPaginationTableThead">
                    <tr>
                      <th scope="col fw-bold">Mobile Number</th>
                      <th scope="col fw-bold">First Name</th>
                      <th scope="col fw-bold">Last Name</th>
                      <th scope="col fw-bold">Email</th>
                      <th scope="col fw-bold">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.activityContactList?.map((rowData, index) => (
                      <tr key={index}>
                        <td style={{ width: "175px" }}>{rowData.mobile}</td>
                        <td style={{ width: "140px" }}>{rowData.firstName}</td>
                        <td style={{ width: "140px" }}>{rowData.lastName}</td>
                        <td style={{ width: "200px" }}>{rowData.email}</td>
                        <td style={{ width: "120px" }}>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                            key={rowData.id}
                          >
                            <span
                              className="me-2"
                              style={{ cursor: "pointer" }}
                            >
                              <RemoveContactButton
                                domainObject={rowData.mobile}
                                onClick={this.deleteContactToGroup.bind(
                                  this,
                                  rowData
                                )}
                                pageId="ActivityContact"
                              />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {this.state.totalRecords === 0 && (
                <div
                  className="row text-center"
                  style={{ padding: "6px 20px" }}
                >
                  <h5 className="dataNotAvailable">No data found.</h5>
                </div>
              )}
              {this.state.totalRecords > this.state.pageSize && (
                <div className="row justify-content-between pagination p-1">
                  <div className="d-flex col-12 col-lg-4 col-xl-4">
                    <div className="pageSize col-12 text-start">
                      Page {this.state.pageNo + 1} of {this.state.totalPages}
                    </div>
                  </div>
                  <div className="d-flex col-12 col-lg-8 col-xl-8">
                    <div className="col-12 text-end">
                      <Pagination
                        showPerPage={this.state.showPerPage}
                        onPaginationChange={this.onPaginationChange.bind(this)}
                        total={this.state.totalRecords}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export default ActivityContactList;
